import {useContext} from 'react';
import ObservabilityConfigContext from 'src/internal/config/ObservabilityConfigContext';

import type {ObservabilityConfig} from 'src/types';

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-observability/api/useObservabilityConfig
 */
export default function useObservabilityConfig(): ObservabilityConfig {
  return useContext(ObservabilityConfigContext);
}
